import {useState} from 'react'
import CleaningWashingForm from './CleaningWashingForm';
import CleaningWashingListview from './CleaningWashingListview';

const CleaningWashing = () => {
    const [fromIsShown, setFromIsShown] = useState(false);
    const [upData, setUpData] = useState(false);
    const [serviceId, setServiceId] = useState("none");
  
    return (
      <>
        {fromIsShown ? (
          <CleaningWashingForm addForm={setFromIsShown} update={upData}  sId={serviceId}/>
        ) : (
          <CleaningWashingListview addForm={setFromIsShown} update={setUpData}  sId={setServiceId}/>
        )}
      </>
  )
}

export default CleaningWashing